<div class="resume">
    <h3 class="content-title">Resume</h3>
  
    <h4>Education</h4>
    <ul>
      <li>PhD - Mechanical Engineering, Stanford University, 1968</li>
    </ul>
    
    <h4>Academic Experience</h4>
    <ul>
      <li>1968 - 2003 &nbsp;&nbsp;&nbsp;&nbsp; Professor, Department of Aeronautics and Astronautics (now Mechanical and Aerospace Engineering), Naval Postgraduate School, 35 years teaching, research and administration; over 35 publications, 14 patents, and 2 books</li>
    </ul>
  
  
  
      <h4>Industrial Experience</h4>
      <ul>
        <li>
          1987 - 1989 &nbsp;&nbsp;&nbsp;&nbsp; GTE - Electrical Products, Senior Research Scientist
        </li>
        <li>
          1961 - 1963 &nbsp;&nbsp;&nbsp;&nbsp; Hughes Space Systems Division
        </li>
      </ul>
  
      <h4>Research Interests</h4>
      <ul>
        <li>
          Aerospace Propulsion -- Fluid Mechanics -- Lasers
        </li>
      </ul>
  
  
      <h4>Awards</h4>
      <ul>
        <li>
          Hughes Master Fellow, 1962-1963 -- Ford Foundation Plasma Fellow, 1966-1967
        </li>
        <li>
          Lady Davis Fellow, 1976-1977 and 2005 -- Navy Superior Service Award, 2003
        </li>
      </ul>
  
      <h4>Memberships</h4>
      <ul>
        <li>
          Senior Member, American Institute of Aeronautics and Astronautics (AIAA)
        </li>
        <li>
          Life Member, American Physical Society (APS)
        </li>
        <li>
          Life Member, Sigma Xi
        </li>
      </ul>
    
      <h4>
          Selected Publications
        </h4>
      
        <ul>
          <li>
            Sutton, G.P. and Biblarz, O., <b>Rocket Propulsion Elements, 9th Edition</b>, Copyright 2017, John Wiley & Sons, Hoboken, NJ
          </li>
          <li>
            Zucker, R.D. and Biblarz, O., <b>Fundamentals of Gas Dynamics, 3rd Edition</b>, John Wiley & Sons, 2020, Hoboken, NJ
          </li>
          <li>
            Biblarz, O., "Ion Accelerator Currents Beyond Child-Langmuir Limit," JPC AIAA 2013-4019, San Jose, CA, July 2013.
          </li>
          <li>
            Biblarz, O. and Romano, M., "Field Ionization Based Electrical Space Ion Thruster Using a Permeable Substrate", US Patent # 9,194,379 dated 11/24/15
          </li>
        </ul> 
  
     
        
  </div>